// extracted by mini-css-extract-plugin
export default {"PipStub":"PipStub--s1paE","PipStub__Icon":"PipStub__Icon--iwKom","PipStub__Text":"PipStub__Text--pvkJa","PipStub_SmallMode":"PipStub_SmallMode--Tz8o8"};